module.exports = __webpack_public_path__ + "img/produto-konjac.28725a64.png";